import React from 'react';
import classNames from 'classnames';
import Redirect from 'react-router-dom/Redirect';
import Link from 'react-router-dom/Link';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Page, Separator, CenterContainer } from '../../components/containers';
import { LoadingSpinner } from '../../components/loaders';
import { ErrorBox, Headline } from '../../components/text';
import { PAGE_CUSTOMER } from '../../App';
import RequestReportForm from './Form';
import {
    getIsReportsListOpen,
    getIsReportsListLoading,
    getHasReportsListFetchFailed,
    getReportsList,
} from '../../selectors';
import { getReportsCategoriesList } from '../ReportsPage/action';
import { REPORT_REQUEST_STATUS } from './constants';
import s from './index.css';

const mapStateToProps = state => ({
    loadingReportsCategoriesList: getIsReportsListLoading(state),
    loadingReportsCategoriesListFailed: getHasReportsListFetchFailed(state),
    reportsCategoriesList: getReportsList(state),
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    getReportsCategoriesList: bindActionCreators(getReportsCategoriesList, dispatch),
});

class RequestReportPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            urlIsWrong: false,
            parsedUrlData: {
                requestId: null,
                requestName: '',
            },
        };
    }

    componentWillMount() {
        this.props.getReportsCategoriesList();

        if (
            this.props.match &&
            this.props.match.params &&
            this.props.match.params.requestId &&
            this.props.match.params.requestName
        ) {
            const requestId = parseInt(this.props.match.params.requestId, 10);
            const requestName = this.props.match.params.requestName;

            this.setState(
                !isNaN(requestId)
                    ? {
                          parsedUrlData: {
                              ...this.state.parsedUrlData,
                              requestId: requestId,
                              requestName: requestName,
                          },
                      }
                    : {
                          urlIsWrong: true,
                      }
            );
        } else {
            this.setState({
                urlIsWrong: true,
            });
        }
    }

    render() {
        const { loadingReportsCategoriesList, loadingReportsCategoriesListFailed, reportsCategoriesList } = this.props;

        return (
            <Page>
                <Separator type="wide" />

                {loadingReportsCategoriesList && (
                    <CenterContainer>
                        <LoadingSpinner size={64} />
                    </CenterContainer>
                )}

                <div className={s.header}>
                    <Headline size="small">Request report</Headline>

                    <Link to={PAGE_CUSTOMER.Reports}>Back to reports history</Link>
                </div>

                {loadingReportsCategoriesListFailed ||
                    (!loadingReportsCategoriesList &&
                        !reportsCategoriesList && (
                            <Fragment>
                                <Separator type="narrow" />

                                <ErrorBox
                                    onClick={this.handleRefetchReportsCategoriesList}
                                    label="Could not load report details, click here to try again"
                                />
                            </Fragment>
                        ))}

                {!loadingReportsCategoriesList &&
                    !loadingReportsCategoriesListFailed &&
                    !this.state.urlIsWrong &&
                    this.state.parsedUrlData.requestId !== null &&
                    reportsCategoriesList && (
                        <RequestReportForm
                            requestId={this.state.parsedUrlData.requestId}
                            requestName={this.state.parsedUrlData.requestName}
                        />
                    )}

                <Separator type="huge" />

                {this.state.urlIsWrong && <Redirect to={PAGE_CUSTOMER.Reports} />}
            </Page>
        );
    }

    handleRefetchReportsCategoriesList = () => {
        this.props.getReportsCategoriesList();
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RequestReportPage);



// WEBPACK FOOTER //
// ./app/web/src/container/RequestReportPage/index.jsx